// extracted by mini-css-extract-plugin
export var main = "Support-module--main--1lZpJ";
export var title = "Support-module--title--1KZE0";
export var content = "Support-module--content--2vFd7";
export var cta = "Support-module--cta--9RHY8";
export var circle = "Support-module--circle--3Tvkc";
export var circleOne = "Support-module--circle-one--3Saa_";
export var circleTwo = "Support-module--circle-two--1lk4F";